// @ts-nocheck
import { useEffect, useRef, useState, Ref, useMemo, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Image from "src/components/image";

import { GLB_AVATAR } from "src/const/navigationConst";

import {
  VenueModelConfig,
  getVenueModelConfigByVenueCode,
  getVenueIdByVenueCode,
  getAltitudeByFloorName,
  getBaseUrl,
} from "src/utils/map-util";


import { initCameraMovement } from "src/const/explorationConst";

import {
  interpolateVector3,
  roundToDecimals,
  vec3Distance,
  hexToRgbArray,
  getYAngleDegree,
  angleDifferenceABtoAC,
  wrapAngle,
  tri,
} from "src/utils/game";
import * as pc from "playcanvas";
import {
  useTexture,
  useMaterial,
  useEnvAtlas,
  useApp,
  useSplat,
  useModel,
} from "@playcanvas/react/hooks";
import { Application, Entity, Gltf } from "@playcanvas/react";
import {
  Render,
  Camera,
  Light,
  GSplat,
  Script,
  Environment,
} from "@playcanvas/react/components";
import { Texture } from "@playcanvas/engine"; // For texture loading

import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";

import WatermarkScreen from "src/components/watermark";
import { useLodSplat } from "src/utils/useLodSplat";

import Lottie from "lottie-react";
import loading from "src/components/lottie/loading.json";

import { GsplatRevealRadial } from 'src/extra_js/reveal-radial.mjs';

export default function PoliceOperationsPage() {
  const { operation } = useParams();
  let policeOperation = operation;
  if(policeOperation != "optimize_resources" && policeOperation != "set_perimeters" && policeOperation != "evacuation_plan"){
    policeOperation = "optimize_resources";
  }
  console.log("police operation", policeOperation)


  const [operationState,setOperationState] = useState<string>("");

  const [venueModelConfigState, setVenueModelConfigState] = useState<number>(0);
  const [modelScaleFactorState, setModelScaleFactorState] =
    useState<number>(0.1);

  const gsplatMainRef = useRef();

  const moveSpeedRef = useRef<number>(1);
  const rotateSpeedRef = useRef<number>(1);
  const downSpeedRef = useRef<number>(1);

  const topPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const downPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const backPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const defaultPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const defaultTargetRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));

  const targetAltitudeRef = useRef<number>(0);

  const latestCurrentLevelNameRef = useRef<string>("");
  const isLevelChangingRef = useRef<boolean>(false);

  const mainObjectEntityRef = useRef();
  const cameraScriptRef = useRef();
  const hiddenNearRef = useRef<pc.Entity>(null);
  const hiddenFarRef = useRef<pc.Entity>(null);
  const firstPersonCameraEntityRef = useRef();
  const thirdPersonCameraEntityRef = useRef();
  const latestCameraModeRef = useRef<number>(0);
  const latestXrayModeRef = useRef<number>(0);

  const transitionTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const revealEffectTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  const [modelLoadedState, setModelLoadedState] = useState(false);
  const [coordReadyState, setCoordReadyState] = useState(false);

  const startPosRef = useRef(new pc.Vec3());
  const endPosRef = useRef(new pc.Vec3());

  const [startTransition, setStartTransition] = useState(false);

  const currentFloorRef = useRef("-1");
  const toggleResetRef = useRef(false);

  // const controls = useRef<any>(null);
  // const navigationObject = useRef<Group | null>(null);
  // const firstPersonCameraVector = useRef<Group | null>(null);
  // const thirdPersonCameraVector = useRef<Group | null>(null);

  const isMovingRef = useRef<boolean>(false);
  const isRotatingRef = useRef<boolean>(false);

  const latestPositionJoystickData = useRef<number[]>([0, 0]);
  const latestRotationJoystickData = useRef<number[]>([0, 0]);
  const latestRotationScreenData = useRef<number[]>([0, 0]);

  const latestResetPositionRotationEvent = useRef<number>(0);
  const latestResetOnlyRotationEvent = useRef<number>(0);
  const leaveVenueRef = useRef<number>(0);

  const latestVenueModelConfigRef = useRef<VenueModelConfig | null>(null);

  const initAnimationRef = useRef("init");

  const isDisplayAvatarRef = useRef<boolean>(false);

  const isDisplayEnteringMaskRef = useRef<boolean>(false);
  const isDisplayLeavingMaskRef = useRef<boolean>(false);

  const isDisplaySceneObject = useRef<boolean>(false);


  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'p') {
        console.log("test");
        if(cameraScriptRef.current){
          console.log(cameraScriptRef.current.entity.position)
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  const DataController = () => {
    const currentVenue = "xiqu";
    useEffect(() => {
      console.log("init data");
      if(!currentVenue){
        return;
      }

      const venueModelConfig = getVenueModelConfigByVenueCode(currentVenue);
      setVenueModelConfigState(venueModelConfig);
      latestVenueModelConfigRef.current = venueModelConfig;
      setModelScaleFactorState(venueModelConfig.scaleFactor);
      setCoordReadyState(true);
    }, [currentVenue]);

    return <></>;
  };

  useEffect(() => {
    setOperationState(policeOperation);
    console.log("!!!! " + policeOperation);
    return () => {
      if (transitionTimeoutRef.current) {
        clearTimeout(transitionTimeoutRef.current);
      }
      if(revealEffectTimeoutRef.current){
        clearTimeout(revealEffectTimeoutRef.current);
      }
    };
  }, []);

  const MainCamera = () => {
    const app = useApp();
    let _localProgress;
    let _localCameraMode;
    let isCameraModeUpdated;
    let nearestFixedCameraPosition;

    let finalCameraPosition;
    let finalCameraLookingPosition;

    let goDownAnimationTime = 0;
    const goDownDuration = 3;

    let orbitAnimationTime = 0;
    const orbitDuration = 5;

    let zoomInAvatarAnimationTime = 0;
    const zoomInAvatarDuration = 1;

    let goUpAnimationTime = 0;
    const goUpDuration = 3;

    app.on("update", function (dt) {
      if (cameraScriptRef.current == null) {
        return;
      }
    });

    useEffect(() => {
      const defaultCameraLookingPosition = new pc.Vec3(
        // venueModelConfigState.defaultPosition[0] / modelScaleFactorState,
        // venueModelConfigState.defaultPosition[1] / modelScaleFactorState,
        // venueModelConfigState.defaultPosition[2] / modelScaleFactorState - 5,
        -57.19691467285156,
        4.83319091796875,
        -63.29683303833008
      );
      const defaultPosition = new pc.Vec3(
        venueModelConfigState.defaultPosition[0] / modelScaleFactorState - 10,
        venueModelConfigState.defaultPosition[1] / modelScaleFactorState + 5,
        venueModelConfigState.defaultPosition[2] / modelScaleFactorState - 15,
      );
      cameraScriptRef.current.reset(
        defaultCameraLookingPosition,
        defaultPosition,
      );
    }, []);

    app.on("update", function (dt) {
      if (cameraScriptRef.current == null) {
        return;
      }
    });

    return (
      <Entity>
        <Camera fov={60} />
        <Script
          ref={cameraScriptRef}
          script={CameraControls}
          // enableFly={false}
        />
        <Entity ref={hiddenNearRef} position={[0, 0, 0]}></Entity>
        <Entity ref={hiddenFarRef} position={[0, 0, -2.5]}></Entity>
      </Entity>
    );
  };

  const MainObject = () => {
    const app = useApp();

    let goDownAnimationTime = 0;
    const goDownDuration = 3;

    let goUpAnimationTime = 0;
    const goUpDuration = 2;

    const eulerRef = useRef(new pc.Vec3(0, 0, 0));
    let _localResetPositionRotationEvent = 0;
    let _localResetOnlyRotationEvent = 0;
    let _localLeaveVenueEvent = 0;
    let temp = false;

    useEffect(() => {
      mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
      mainObjectEntityRef.current.lookAt(0,0,0);
      let angles = mainObjectEntityRef.current.getLocalEulerAngles();
      // eulerRef.current.set(angles.x,angles.y,angles.z)
    }, []);

    app.on("update", function (dt) {
      if (mainObjectEntityRef.current == null) {
        return;
      }
      let isResetPositionRotation =
        _localResetPositionRotationEvent !=
        latestResetPositionRotationEvent.current;
      _localResetPositionRotationEvent =
        latestResetPositionRotationEvent.current;
      let isResetOnlyRotation =
        _localResetOnlyRotationEvent != latestResetOnlyRotationEvent.current;
      _localResetOnlyRotationEvent = latestResetOnlyRotationEvent.current;

      let isLeaveVenue = _localLeaveVenueEvent != leaveVenueRef.current;
      _localLeaveVenueEvent = leaveVenueRef.current;

      if (initAnimationRef.current == "free") {
        if (latestPositionJoystickData.current.length != 2) {
          return;
        }

        if (isLevelChangingRef.current) {
          isMovingRef.current = true;
          const targetPosition = new pc.Vec3(
            mainObjectEntityRef.current.getPosition().x,
            targetAltitudeRef.current,
            mainObjectEntityRef.current.getPosition().z,
          );
          const distance = vec3Distance(
            mainObjectEntityRef.current.getPosition(),
            targetPosition,
          );
          const positionAlpha = Math.min(1, (3 * dt) / distance);
          mainObjectEntityRef.current.setPosition(targetPosition);
          isLevelChangingRef.current = false;
        }

        if (
          latestPositionJoystickData.current[0] != 0 ||
          latestPositionJoystickData.current[1] != 0
        ) {
          isMovingRef.current = true;
          const worldMat = mainObjectEntityRef.current.getWorldTransform();
          const forward = new pc.Vec3(0, 0, -1);
          worldMat.transformVector(forward, forward);
          forward.y = 0;
          forward.normalize();
          const up = pc.Vec3.UP.clone();
          const right = new pc.Vec3();
          right.cross(up, forward).normalize();
          const forwardScale =
            latestPositionJoystickData.current[1] * moveSpeedRef.current * -dt;
          const rightScale =
            latestPositionJoystickData.current[0] * moveSpeedRef.current * -dt;
          const forwardMove = forward.clone().mulScalar(forwardScale);
          const rightMove = right.clone().mulScalar(rightScale);
          const move = new pc.Vec3();
          move.add(forwardMove).add(rightMove);
          mainObjectEntityRef.current.translate(move);
        }

        if (
          latestRotationJoystickData.current[0] != 0 ||
          latestRotationJoystickData.current[1] != 0
        ) {
          isRotatingRef.current = true;

          eulerRef.current.y +=
            -latestRotationJoystickData.current[0] *
            rotateSpeedRef.current *
            dt; // Yaw
          eulerRef.current.x +=
            -latestRotationJoystickData.current[1] *
            rotateSpeedRef.current *
            dt; // Pitch

          eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
          eulerRef.current.y = wrapAngle(eulerRef.current.y);

          mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
        }

        if (
          latestRotationScreenData.current[0] != 0 ||
          latestRotationScreenData.current[1] != 0
        ) {
          isRotatingRef.current = true;

          eulerRef.current.y +=
            -latestRotationScreenData.current[0] * rotateSpeedRef.current * dt; // Yaw
          eulerRef.current.x +=
            -latestRotationScreenData.current[1] * rotateSpeedRef.current * dt; // Pitch

          eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
          eulerRef.current.y = wrapAngle(eulerRef.current.y);

          mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
        }
      }
    });

    return (
      <Entity ref={mainObjectEntityRef}>
        <Entity
          ref={firstPersonCameraEntityRef}
          position={[0, 0, 0.5]}
        ></Entity>
        <Entity
          ref={thirdPersonCameraEntityRef}
          position={[0, 0.5, 4]}
        ></Entity>
      </Entity>
    );
  };

  const installCameraNearFar = (
    app: pc.Application,
    gsplatEntity: pc.Entity,
  ) => {
    const device = app.graphicsDevice;
    const gsplatMat =
      app.scene.gsplat.material || gsplatEntity.gsplat?.material;
    if (!gsplatMat) return () => {};

    if (!hiddenNearRef.current || !hiddenFarRef.current) {
      return () => {};
    }

    const glsl = `
      uniform vec3 uCutA;       // camera position in WORLD space
      uniform vec3 uCutB;       // robot position in WORLD space
      uniform float uCutRadius; // cylinder radius of the cutaway
      uniform float uCutFeather;// soft edge transition distance

      // Calculate the shortest distance from a point (p) to a line segment (a to b)
      float segDist(vec3 p, vec3 a, vec3 b) {
        vec3 pa = p - a;
        vec3 ba = b - a;
        float h = clamp(dot(pa, ba) / max(dot(ba, ba), 1e-6), 0.0, 1.0);
        return length(pa - ba * h);
      }

      void modifySplatCenter(inout vec3 center) {
      }

      void modifySplatRotationScale(vec3 originalCenter, vec3 modifiedCenter, inout vec4 rotation, inout vec3 scale) {
        // Calculate distance between current splat and the Camera-Robot line segment
        float d = segDist(originalCenter, uCutA, uCutB);
        float alpha = smoothstep(uCutRadius, uCutRadius + uCutFeather, d);

        // Scale down splats that are too close to the line to 0, making them disappear
        scale *= alpha;
      }

      void modifySplatColor(vec3 center, inout vec4 color) {
        // Apply the same transition to the alpha channel as a double-safeguard
        float d = segDist(center, uCutA, uCutB);
        float alpha = smoothstep(uCutRadius, uCutRadius + uCutFeather, d);
        color.a *= alpha;
      }
    `;

    gsplatMat.getShaderChunks("glsl").set("gsplatModifyVS", glsl);
    gsplatMat.update();

    const uCutA = device.scope.resolve("uCutA");
    const uCutB = device.scope.resolve("uCutB");
    const uCutRadius = device.scope.resolve("uCutRadius");
    const uCutFeather = device.scope.resolve("uCutFeather");
    uCutRadius.setValue(1);
    uCutFeather.setValue(0.01);

    const onUpdate = () => {
      if (!hiddenNearRef.current || !hiddenFarRef.current) {
        return;
      }
      const nearPosition = hiddenNearRef.current.getPosition().clone();
      const farPosition = hiddenFarRef.current.getPosition().clone();
      if (nearPosition.length() === 0 || isNaN(nearPosition.x)) return;
      const dirToCamera = new pc.Vec3().sub2(nearPosition, farPosition);
      const totalDist = dirToCamera.length();
      dirToCamera.normalize();
      uCutA.setValue([nearPosition.x, nearPosition.y, nearPosition.z]);
      uCutB.setValue([farPosition.x, farPosition.y, farPosition.z]);
    };
    app.on("update", onUpdate);
    return () => app.off("update", onUpdate);
  };

  const VenueLod = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    // const { asset, loading, error, lodDistances, subscribe } = useLodSplat(
    //   venueModelConfigState!.baseUrl + venueModelConfigState!.lod,
    // );
    const { asset, loading, error, lodDistances, subscribe } = useLodSplat(
      baseUrl + venueModelConfigState!.folderPath + venueModelConfigState!.lod,
    );

    const createRadialScript = () => {
        const script = gsplatMainRef.current.script?.create(GsplatRevealRadial);
        if (script) {
            script.center.set(-47,0,-52);
            script.speed = 10;
            script.acceleration = 0;
            script.delay = 1;
            script.dotTint.set(0, 1, 1); // Cyan
            script.waveTint.set(0, 1, 0); // Orange
            script.oscillationIntensity = 1;
            script.endRadius = 10000;
        }
        return script;
    };


    useEffect(() => {
      if (!asset) {
        return;
      }
      const gsplatEntity = gsplatMainRef.current;
      console.log(gsplatEntity);
      if (!gsplatEntity || !app) return;
      gsplatEntity.gsplat.enabled = false;
      gsplatEntity.gsplat.unified = true;
      gsplatEntity.gsplat.asset = asset;
      gsplatEntity.gsplat.lodDistances = [
        100 * modelScaleFactorState,
        150 * modelScaleFactorState,
        500 * modelScaleFactorState,
      ];
      gsplatEntity.gsplat.enabled = true;
      //app.scene.gsplat.colorizeLod = true;
      setModelLoadedState(true);
      isDisplayEnteringMaskRef.current = false;
      isDisplaySceneObject.current = true;
      initAnimationRef.current = "free";

      gsplatEntity.addComponent('script');
      //createRadialScript();

      revealEffectTimeoutRef.current = setTimeout(() => {
        createRadialScript();
      }, 100)

      // if (gsplatMainRef.current?.gsplat) {
      //   const opacity = 1
      //   gsplatMainRef.current.gsplat.setWorkBufferModifier({
      //     glsl: `
      //       void modifySplatCenter(inout vec3 center) {}
      //       void modifySplatRotationScale(vec3 originalCenter, vec3 modifiedCenter, inout vec4 rotation, inout vec3 scale) {}
      //       void modifySplatColor(vec3 center, inout vec4 color) { color.a *= ${opacity.toFixed(1)}; }
      //     `,
      //   });
      // }

      const cleanup = installCameraNearFar(app, gsplatEntity);
      return cleanup;
    }, [asset]);

    return (
      <Entity
        ref={gsplatMainRef}
        rotation={[180, 0, 0]}
        position={[0, 0, 0]}
        scale={[
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
        ]}
      >
        <GSplat />
      </Entity>
    );
  };


  const CharacterModel = ({url, position, rotation }) => {
    const app = useApp();
    const entityRef = useRef();
    const { asset: model } = useModel(
      url
    );
    const changeMaterial = (entity) => {
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const material = meshInstance.material;
            if (material) {
              material.emissive =
                material.diffuse?.clone() || new pc.Color(0, 0, 0);
              if (material.diffuseMap) {
                material.emissiveMap = material.diffuseMap;
              }
              material.emissiveIntensity = 1.0;
              material.useLighting = false;
              material.update();
            }
          });
        }
      });
    };

    useEffect(() => {
      if (model && entityRef.current) {
        entityRef.current.enabled = false;
        requestAnimationFrame(() => {
          changeMaterial(entityRef.current);
        });
      }
    }, [model]);

    app.on("update", function (dt) {
      if (entityRef.current) {
        entityRef.current.enabled = isDisplaySceneObject.current;
      }
    });

    return model ? (
      <Entity position={position} rotation={rotation}>
        <Entity ref={entityRef} scale={[0.3, 0.3, 0.3]}>
          <Render type="asset" asset={model} />
        </Entity>
      </Entity>
    ) : (
      <></>
    );
  };
  const SceneOptimizeResources = () => {

    const policeModelUrl = "https://assets.deepworldmodel.ai/crime_simulation/elements/police.glb";
    const material1 = useMaterial({
      emissiveIntensity: 2.5,
      emissive: [0.996, 0.184, 0.016],
      useLighting: false,
      useSkybox: false,
      blendType: pc.BLEND_ADDITIVEALPHA,
      opacity: 0,
    });

    const material2 = useMaterial({
      emissiveIntensity: 2.5,
      emissive: [0, 1, 0],
      useLighting: false,
      useSkybox: false,
      blendType: pc.BLEND_ADDITIVEALPHA,
      opacity: 0,
    });
    return(
      <Entity>
        <CharacterModel url={policeModelUrl} position={[-45.63,-1.2,-46.241]} rotation={[0,0,0]}/>
        <CharacterModel url={policeModelUrl} position={[-38,-1.2,-56]} rotation={[0,220,0]}/>
        <CharacterModel url={policeModelUrl} position={[-44,-1.2,-62]} rotation={[0,240,0]}/>
        <CharacterModel url={policeModelUrl} position={[-50,-1.2,-58]} rotation={[0,200,0]}/>
        <CharacterModel url={policeModelUrl} position={[-54,-1.2,-53]} rotation={[0,250,0]}/>
      </Entity>
    )
  }


  const SceneSetPerimeters = () => {
    const app = useApp();
    const entityGroup = useRef();
    const entityRefA1 = useRef();
    const entityRefA2 = useRef();
    const entityRefA3 = useRef();
    const entityRefA4 = useRef();

    const entityRefB1 = useRef();
    const entityRefB2 = useRef();
    const entityRefB3 = useRef();
    const entityRefB4 = useRef();

    const entityRefC = useRef();

    const setARefs = [entityRefA1,entityRefA2,entityRefA3,,entityRefA4];
    const setBRefs = [entityRefB1,entityRefB2,entityRefB3,,entityRefB4];
    const setCRefs = [entityRefC];

    app.on("update", function (dt) {
      if (entityGroup.current) {
        entityGroup.current.enabled = isDisplaySceneObject.current;
      }
    });

    useEffect(() => {
      entityGroup.current.enabled = false;
      setARefs.forEach((ref, index) => {
        if (ref.current) {
          const meshInstance = ref.current.render.meshInstances[0];
          const material = meshInstance.material.clone();
          meshInstance.material = material;
          material.emissiveMap = material.diffuseMap;
          material.emissiveIntensity = 2.5;
          material.emissive.set(1, 0.498, 0);
          material.useLighting = false;
          // material.useSkybox = false;
          material.blendType = pc.BLEND_NORMAL;
          material.opacity = 0.5;
          material.update();
        }
      });

      setBRefs.forEach((ref, index) => {
        if (ref.current) {
          const meshInstance = ref.current.render.meshInstances[0];
          const material = meshInstance.material.clone();
          meshInstance.material = material;
          material.emissiveMap = material.diffuseMap;
          material.emissiveIntensity = 2.5;
          material.emissive.set(1, 0, 0);
          material.useLighting = false;
          // material.useSkybox = false;
          material.blendType = pc.BLEND_NORMAL;
          material.opacity = 0.5;
          material.update();
        }
      });

      setCRefs.forEach((ref, index) => {
        if (ref.current) {
          const meshInstance = ref.current.render.meshInstances[0];
          const material = meshInstance.material.clone();
          meshInstance.material = material;
          material.emissiveMap = material.diffuseMap;
          material.emissiveIntensity = 2.5;
          material.emissive.set(0, 0, 1);
          material.useLighting = false;
          // material.useSkybox = false;
          material.blendType = pc.BLEND_NORMAL;
          material.opacity = 0.5;
          material.update();
        }
      });

      console.log(entityRefC.current.getPosition());
    }, []);

    return(
      <Entity>
        <Entity ref={entityGroup} position={[-47,0,-50]}  rotation={[0,20,0]}>
          <Entity rotation={[0,0,0]}>
            <Entity ref={entityRefA1} name='box' position={[11,0,-7]} rotation={[0,90,0]} scale={[8,2,0.5]}>
              <Render type='box'/>
            </Entity>
            <Entity ref={entityRefA2} name='box' position={[0.5,-1.5,-17]} rotation={[0,-30,0]} scale={[25,5,0.5]}>
              <Render type='box'/>
            </Entity>
{/*            <Entity ref={entityRefA2} name='box' position={[-2.6,0,0]} rotation={[0,90,0]} scale={[5,2,0.5]}>
              <Render type='box'/>
            </Entity>
            <Entity ref={entityRefA3} name='box' position={[0,0,2.6]} rotation={[0,0,0]} scale={[5,2,0.5]}>
              <Render type='box'/>
            </Entity>
            <Entity ref={entityRefA4} name='box' position={[0,0,-2.6]} rotation={[0,0,0]} scale={[5,2,0.5]}>
              <Render type='box'/>
            </Entity>*/}
          </Entity>
          
          <Entity rotation={[0,0,0]}>
            <Entity ref={entityRefB1} name='box' position={[5,0,0]} rotation={[0,90,0]} scale={[15,2,0.5]}>
              <Render type='box'/>
            </Entity>
            <Entity ref={entityRefB2} name='box' position={[-5,0,0]} rotation={[0,90,0]} scale={[15,2,0.5]}>
              <Render type='box'/>
            </Entity>
            <Entity ref={entityRefB3} name='box' position={[0,0,7.3]} rotation={[0,0,0]} scale={[9.5,2,0.5]}>
              <Render type='box'/>
            </Entity>
            <Entity ref={entityRefB4} name='box' position={[0,0,-7.3]} rotation={[0,0,0]} scale={[9.5,2,0.5]}>
              <Render type='box'/>
            </Entity>
          </Entity>

          <Entity rotation={[0,0,0]}>
            <Entity ref={entityRefC} name='box' position={[0,0,4]} rotation={[0,0,0]} scale={[3,2,3]}>
              <Render type='box'/>
            </Entity>
          </Entity>

        </Entity>
      </Entity>
    )
  }

  const SceneEvacuationPlan = () => {
    const citizenModelUrl = "https://assets.deepworldmodel.ai/crime_simulation/elements/citizenM.glb";
    const app = useApp();
    return(
      <Entity>
        <WalkPathsContainer1/>
        <WalkPathsContainer2/>
        <WalkPathsContainer3/>
        <CharacterModel url={citizenModelUrl} position={[-45.63,-1.2,-46.241]} rotation={[0,180,0]}/>
      </Entity>
    )
  }


  const WalkPathsContainer1 = () => {
    const app = useApp();
    const isPointsSetup = useRef<boolean>(false);
    const [points, setPoints] = useState<number[][] | null>([
      [-45.63,-0.3,-46.241],
      [-45.33784484863281,-0.3,-49.05818176269531],
      [-44.10762405395508,-0.3,-52.016971588134766],
      [-43.03700256347656,-0.3,-56.893775939941406],
      [-37.827423095703125,-0.3,-58.731956481933594],
      [-32.95499038696289,-0.3,-61.562198638916016],
      [-25.12522315979004,-0.3,-65.50511932373047],
      [-15.925284385681152,-0.3,-68.36618041992188]
    ]);
    return points != null ? <WalkPaths points={points} /> : <></>;
    return <></>
  };

  const WalkPathsContainer2 = () => {
    const app = useApp();
    const isPointsSetup = useRef<boolean>(false);
    const [points, setPoints] = useState<number[][] | null>([
      [-45.63,-0.3,-46.241],
      [-47.00678634643555,-0.3,-49.68672561645508],
      [-47.14403533935547,-0.3,-54.24219512939453],
      [-45.237239837646484,-0.3,-57.59031677246094],
      [-44.63575744628906,-0.3,-61.95151138305664],
      [-49.6661262512207,-2.5,-64.13838195800781],
      [-58.00922393798828,-2.5,-69.57134246826172]
    ]);
    return points != null ? <WalkPaths points={points} /> : <></>;
    return <></>
  };

  const WalkPathsContainer3 = () => {
    const app = useApp();
    const isPointsSetup = useRef<boolean>(false);
    const [points, setPoints] = useState<number[][] | null>([
      [-45.63,-0.3,-46.241],
      [-44.17635726928711,-0.3,-43.66745376586914],
      [-42.460697174072266,-0.3,-38.01747131347656],
      [-55.05774688720703, -3, -37.361732482910156],
      [-57.270050048828125,-3,-34.21317672729492],
      [-59.57283020019531,-3,-24.13656234741211]
    ]);
    return points != null ? <WalkPaths points={points} /> : <></>;
    return <></>
  };

  const WalkPaths = ({ points }: { points: number[][] }) => {
    const segments = points.slice(0, -1).map((start, i) => {
      const end = points[i + 1];
      const length = Math.hypot(
        end[0] - start[0],
        end[1] - start[1],
        end[2] - start[2],
      );
      return (
        <>
          <EachWalkPath
            key={i}
            start={start}
            end={end}
            length={length}
            pathIndex={i + 1}
            pathLength={points.length - 1}
          />
        </>
      );
    });
    return (
      <>
        {segments}
      </>
    );
  };

  const EachWalkPath = ({ start, end, length, pathIndex, pathLength }) => {
    const app = useApp();
    const entityRef = useRef();
    const innerBoxRef = useRef();
    const outerBoxRef = useRef();
    const outerBox2Ref = useRef();
    const outerBox3Ref = useRef();

    const pathCorrespondingPercentage = useRef<number>(-1);

    useEffect(() => {
      const innerMeshInstance = innerBoxRef.current.render.meshInstances[0];
      const innerMaterial = innerMeshInstance.material;
      const newInnerMaterial = innerMaterial.clone();
      innerMeshInstance.material = newInnerMaterial;
      newInnerMaterial.emissiveMap = newInnerMaterial.diffuseMap;
      newInnerMaterial.emissiveIntensity = 2.5;
      newInnerMaterial.useLighting = false;
      newInnerMaterial.useSkybox = false;
      newInnerMaterial.emissive.set(1, 1, 0.176);
      // newInnerMaterial.diffuse.set(0.663, 0.663, 0.027);
      // newInnerMaterial.blendType = pc.BLEND_NONE;
      newInnerMaterial.blendType = pc.BLEND_NORMAL;
      newInnerMaterial.opacity = 0.1;

      const outerRefs = [outerBoxRef, outerBox2Ref, outerBox3Ref];
      const opacities = [0.5, 0.2, 0.1];

      outerRefs.forEach((ref, index) => {
        if (ref.current) {
          const meshInstance = ref.current.render.meshInstances[0];
          const material = meshInstance.material.clone();
          meshInstance.material = material;

          material.emissiveMap = material.diffuseMap;
          material.emissiveIntensity = 2.5;
          material.emissive.set(0.996, 0.184, 0.016);
          material.useLighting = false;
          material.useSkybox = false;
          material.blendType = pc.BLEND_ADDITIVEALPHA;
          material.opacity = opacities[index];
          material.update();
        }
      });

      entityRef.current.setPosition(new pc.Vec3(start[0], start[1], start[2]));
      entityRef.current.lookAt(new pc.Vec3(end[0], end[1], end[2]));
      if (start[1] == end[1]) {
        entityRef.current.setLocalScale(0.3, 0.05, length + 0.2);
        entityRef.current.translateLocal(0, -0.5, -length / 2);
      } else {
        if(start[1] > end[1]){
          entityRef.current.setLocalScale(0.3, 0.05, length + 0.075);
          entityRef.current.translateLocal(0, -0.45, -length / 2 - 0.2);
        }
        else{
          entityRef.current.setLocalScale(0.3, 0.05, length + 0.075);
          entityRef.current.translateLocal(0, -0.45, -length / 2 + 0.2);
        }

      }

      entityRef.current.enabled = true;
    }, []);

    // useEffect(() => {
    //   app.on("update", frameUpdate);
    //   return () => app.off("update", frameUpdate);
    // }, [app]);

    // const frameUpdate = (dt: number) => {
    //   if (entityRef.current == null) {
    //     return;
    //   }
    //   if (pathCorrespondingPercentage.current == -1) {
    //     const entries = Object.entries(
    //       latestNavigationPercentagePositionDictionary.current,
    //     );
    //     for (let i = 0; i < entries.length; i++) {
    //       if (
    //         end[0] == entries[i][1][0] &&
    //         end[1] == entries[i][1][1] &&
    //         end[2] == entries[i][1][2]
    //       ) {
    //         pathCorrespondingPercentage.current = entries[i][0];
    //       }
    //     }
    //   }
    //   if (
    //     latestProgressRef.current > pathCorrespondingPercentage.current &&
    //     latestXrayModeRef.current == 2 &&
    //     latestCameraModeRef.current == 1
    //   ) {
    //     entityRef.current.enabled = true;
    //   } else {
    //     entityRef.current.enabled = false;
    //   }
    // };

    return (
      <Entity ref={entityRef}>
        <Entity ref={innerBoxRef} scale={[1, 1, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBoxRef} scale={[1.2, 1.2, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBox2Ref} scale={[1.4, 1.4, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBox3Ref} scale={[1.6, 1.6, 1]}>
          <Render type="box" />
        </Entity>
      </Entity>
    );
  };


  const PlaycanvasScene = () => {
    const app = useApp();
    return (
      <>
        {venueModelConfigState!.lod ? <VenueLod /> : <></>}
        <MainObject />
        <MainCamera />
        {
          operationState == "optimize_resources" ?
          <Entity>
            <SceneOptimizeResources/>
            <SceneSetPerimeters/>
          </Entity>
          : operationState == "set_perimeters" ? 
          <Entity>
            <SceneSetPerimeters/>
          </Entity>
          : operationState == "evacuation_plan" ? 
          <Entity>
            <SceneEvacuationPlan/>
          </Entity>
          : <></>
        }
      </>
    );
  };

  const Scene = () => {
    return (
      <Application>
        {venueModelConfigState != null && modelScaleFactorState > 0 ? (
          <PlaycanvasScene />
        ) : (
          <></>
        )}
      </Application>
    );
  };

  const DragController = () => {
    const isDraggingRef = useRef(false);
    const startPosRef = useRef({ x: 0, y: 0 });
    const previousPositionRef = useRef({ x: 0, y: 0 });
    const getClientPos = (e) => {
      if (e.touches && e.touches.length > 0) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
      return { x: e.clientX, y: e.clientY };
    };
    const handleStart = useCallback((e) => {
      const pos = getClientPos(e);
      isDraggingRef.current = true;
      previousPositionRef.current = { x: pos.x, y: pos.y };
    }, []);
    const handleMove = useCallback((e) => {
      if (!isDraggingRef.current) {
        return;
      }
      const pos = getClientPos(e);
      const xChange = pos.x - previousPositionRef.current.x;
      const yChange = pos.y - previousPositionRef.current.y;
      previousPositionRef.current = { x: pos.x, y: pos.y };
      latestRotationScreenData.current[0] = xChange * 0.5;
      latestRotationScreenData.current[1] = yChange * 0.5;
    }, []);
    const handleEnd = useCallback(() => {
      isDraggingRef.current = false;
      latestRotationScreenData.current[0] = 0;
      latestRotationScreenData.current[1] = 0;
    }, []);
    useEffect(() => {
      window.addEventListener("mouseup", handleEnd);
      window.addEventListener("touchend", handleEnd);
      return () => {
        window.removeEventListener("mouseup", handleEnd);
        window.removeEventListener("touchend", handleEnd);
      };
    }, []);

    return (
      <div
        className="fullscreen_div"
        onMouseDown={handleStart}
        onTouchStart={handleStart}
        onMouseMove={handleMove}
        onTouchMove={handleMove}
        onMouseUp={handleEnd}
        onTouchEnd={handleEnd}
      ></div>
    );
  };

  const EnterLoading = () => {
    const [isDisplayMask, setIsDisplayMask] = useState<boolean>(true);
    const opacityRef = useRef<number>(1);
    const divRef = useRef<HTMLDivElement>(null);
    const EACH_OPACITY = 0.02;
    const animationRef = useRef<number>(0);
    const keepCheckLoading = () => {
      if (!isDisplayEnteringMaskRef.current) {
        opacityRef.current =
          opacityRef.current > EACH_OPACITY
            ? opacityRef.current - EACH_OPACITY
            : 0;
      } else {
        opacityRef.current =
          opacityRef.current < 1 - EACH_OPACITY
            ? opacityRef.current + EACH_OPACITY
            : 1;
      }
      if (divRef.current) {
        divRef.current.style.opacity = opacityRef.current.toString();
      }
      setIsDisplayMask(opacityRef.current > 0);

      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);

    return isDisplayMask ? (
      <div
        ref={divRef}
        className={`fullscreen_div flex items-center justify-center z-[60]`}
      >
        <div className="fullscreen_div bg-[#FFFFFF99] backdrop-blur-md"></div>
        <div className="h-25 w-25 flex items-center justify-center">
          <Lottie animationData={loading} loop={true} />
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const LeaveLoading = () => {
    const [isDisplayMask, setIsDisplayMask] = useState<boolean>(false);
    const opacityRef = useRef<number>(0);
    const divRef = useRef<HTMLDivElement>(null);
    const animationRef = useRef<number>(0);
    const EACH_OPACITY = 0.02;
    const keepCheckLoading = () => {
      if (!isDisplayLeavingMaskRef.current) {
        opacityRef.current =
          opacityRef.current > EACH_OPACITY
            ? opacityRef.current - EACH_OPACITY
            : 0;
      } else {
        opacityRef.current =
          opacityRef.current < 1 - EACH_OPACITY
            ? opacityRef.current + EACH_OPACITY
            : 1;
      }
      if (divRef.current) {
        divRef.current.style.opacity = opacityRef.current.toString();
      }
      setIsDisplayMask(opacityRef.current > 0);

      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);

    return isDisplayMask ? (
      <div
        ref={divRef}
        className={`fullscreen_div flex items-center justify-center z-[60]`}
      >
        <div className="fullscreen_div bg-[#FFFFFF99] backdrop-blur-md"></div>
        <div className="h-25 w-25 flex items-center justify-center">
          <Lottie animationData={loading} loop={true} />
        </div>
      </div>
    ) : (
      <></>
    );
  };

  console.log(
    "PoliceOperationsPage component rendered , if this keep showing, something wrong",
  );
  return (
    <div
      className="absolute top-0 left-0 w-full h-full"
      style={{ backgroundColor: "black" }}
    >
      <DataController />
      <Scene />
      {/*<DragController />*/}
      <EnterLoading />
      <LeaveLoading />
      <WatermarkScreen />
    </div>
  );
}
